// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pat-timeline-modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.45);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
  }
  
  .pat-timeline-modal-content {
    background: var(--clr-white);
    width: 75%;
    max-height: 90vh;
    overflow-y: auto;
    padding: 2rem 2rem 1.5rem;
    border-radius: var(--radius);
    box-shadow: var(--shadow-4);
    position: relative;
    animation: fadeInUp 0.3s ease-in-out;
    font-family: var(--ff-primary);
  }
  
  @keyframes fadeInUp {
    from {
      transform: translateY(24px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
  
  .pat-timeline-close-btn {
    position: absolute;
    top: 14px;
    right: 18px;
    font-size: 1.2rem;
    background-color: var(--clr-grey-9);
    border: none;
    border-radius: 50%;
    width: 34px;
    height: 34px;
    cursor: pointer;
    font-weight: bold;
    color: var(--clr-grey-3);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: var(--transition);
  }
  
  .pat-timeline-close-btn:hover {
    background-color: var(--clr-grey-8);
    transform: rotate(90deg);
  }
  
  .pat-timeline-modal-header {
    font-size: 1.5rem;
    margin-bottom: 1.5rem;
    font-weight: 600;
    color: var(--clr-grey-1);
    text-align: center;
    border-bottom: 1px solid var(--clr-grey-8);
    padding-bottom: 0.5rem;
  }
  
  .pat-modal-section {
    margin-bottom: 2rem;
  }
  
  .pat-modal-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 0.5rem;
    font-size: 0.95rem;
    color: var(--clr-grey-3);
  }
  
  .pat-modal-label {
    font-weight: 500;
    color: var(--clr-primary-5);
    min-width: 130px;
  }
  
  .pat-modal-value {
    color: var(--clr-grey-2);
    flex: 1 1;
    /* text-align: right; */
    word-break: break-word;
  }
  
  .pat-modal-split {
    display: flex;
    gap: 1.5rem;
    flex-wrap: wrap;
  }
  
  .pat-modal-box {
    flex: 1 1 48%;
    /* background: var(--clr-primary-10); */
    border: 1px solid var(--clr-primary-7);
    border-left: 4px solid var(--clr-primary-6);
    border-radius: var(--radius);
    padding: 1.25rem 1rem;
    box-shadow: var(--shadow-1);
    transition: box-shadow 0.3s ease-in-out;
  }
  
  .pat-modal-box:hover {
    box-shadow: var(--shadow-3);
  }
  
  .pat-modal-subheader {
    font-size: 1.05rem;
    font-weight: 600;
    color: var(--clr-primary-5);
    margin-bottom: 0.75rem;
    border-bottom: 1px solid var(--clr-primary-6);
    padding-bottom: 0.3rem;
  }
  
  .pat-modal-box .pat-modal-row {
    margin-bottom: 0.4rem;
    font-size: 0.9rem;
  }
  
  .pat-modal-value.single-line {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  @media (max-width: 1024px) {
    .pat-modal-split {
      flex-direction: column;
    }
  
    .pat-modal-box {
      flex: 1 1 100%;
    }
  }
  
  @media (max-width: 768px) {
    .pat-modal-label {
      min-width: 100px;
    }
  
    .pat-modal-row {
      flex-direction: column;
      align-items: flex-start;
    }
  
    .pat-modal-value {
      text-align: left;
      margin-top: 0.2rem;
    }
  }
  
/* Responsive Styles */

@media (max-width: 768px) {
    .pat-timeline-modal-content {
      width: 90%;
      padding: 1.5rem 1rem;
      max-height: 85vh;
      overflow-y: auto;
      display: flex;
      flex-direction: column;
    }
  
    .pat-timeline-modal-header {
      font-size: 1.25rem;
      padding-bottom: 0.4rem;
    }
  
    .pat-modal-subheader {
      font-size: 1rem;
    }
  
    .pat-modal-box {
      padding: 1rem;
      flex: 1 1 auto;
      overflow-wrap: break-word;
      word-break: break-word;
    }
  
    .pat-modal-label {
      font-size: 0.95rem;
    }
  
    .pat-modal-value {
      font-size: 0.95rem;
    }
  
    .pat-modal-section,
    .pat-modal-split {
      flex-shrink: 0;
    }
  }
  
  @media (max-width: 480px) {
    .pat-timeline-modal-content {
      width: 95%;
      padding: 1rem 0.75rem;
      max-height: 85vh;
      overflow-y: auto;
      display: flex;
      flex-direction: column;
    }
  
    .pat-timeline-close-btn {
      top: 10px;
      right: 12px;
      width: 30px;
      height: 30px;
      font-size: 1rem;
    }
  
    .pat-modal-subheader {
      font-size: 0.95rem;
    }
  
    .pat-modal-box {
      padding: 0.75rem;
      flex: 1 1 auto;
      overflow-wrap: break-word;
      word-break: break-word;
    }
  
    .pat-modal-label,
    .pat-modal-value {
      font-size: 0.9rem;
    }
  
    .pat-modal-section,
    .pat-modal-split {
      flex-shrink: 0;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/components/PatientTimeline/AppointmentModal.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,QAAQ;IACR,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;EACf;;EAEA;IACE,4BAA4B;IAC5B,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;IACzB,4BAA4B;IAC5B,2BAA2B;IAC3B,kBAAkB;IAClB,oCAAoC;IACpC,8BAA8B;EAChC;;EAEA;IACE;MACE,2BAA2B;MAC3B,UAAU;IACZ;IACA;MACE,wBAAwB;MACxB,UAAU;IACZ;EACF;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,iBAAiB;IACjB,mCAAmC;IACnC,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,wBAAwB;IACxB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,6BAA6B;EAC/B;;EAEA;IACE,mCAAmC;IACnC,wBAAwB;EAC1B;;EAEA;IACE,iBAAiB;IACjB,qBAAqB;IACrB,gBAAgB;IAChB,wBAAwB;IACxB,kBAAkB;IAClB,0CAA0C;IAC1C,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;EAC1B;;EAEA;IACE,gBAAgB;IAChB,2BAA2B;IAC3B,gBAAgB;EAClB;;EAEA;IACE,wBAAwB;IACxB,SAAO;IACP,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,uCAAuC;IACvC,sCAAsC;IACtC,2CAA2C;IAC3C,4BAA4B;IAC5B,qBAAqB;IACrB,2BAA2B;IAC3B,uCAAuC;EACzC;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,2BAA2B;IAC3B,sBAAsB;IACtB,6CAA6C;IAC7C,sBAAsB;EACxB;;EAEA;IACE,qBAAqB;IACrB,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE;MACE,sBAAsB;IACxB;;IAEA;MACE,cAAc;IAChB;EACF;;EAEA;IACE;MACE,gBAAgB;IAClB;;IAEA;MACE,sBAAsB;MACtB,uBAAuB;IACzB;;IAEA;MACE,gBAAgB;MAChB,kBAAkB;IACpB;EACF;;AAEF,sBAAsB;;AAEtB;IACI;MACE,UAAU;MACV,oBAAoB;MACpB,gBAAgB;MAChB,gBAAgB;MAChB,aAAa;MACb,sBAAsB;IACxB;;IAEA;MACE,kBAAkB;MAClB,sBAAsB;IACxB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,aAAa;MACb,cAAc;MACd,yBAAyB;MACzB,sBAAsB;IACxB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;;MAEE,cAAc;IAChB;EACF;;EAEA;IACE;MACE,UAAU;MACV,qBAAqB;MACrB,gBAAgB;MAChB,gBAAgB;MAChB,aAAa;MACb,sBAAsB;IACxB;;IAEA;MACE,SAAS;MACT,WAAW;MACX,WAAW;MACX,YAAY;MACZ,eAAe;IACjB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,gBAAgB;MAChB,cAAc;MACd,yBAAyB;MACzB,sBAAsB;IACxB;;IAEA;;MAEE,iBAAiB;IACnB;;IAEA;;MAEE,cAAc;IAChB;EACF","sourcesContent":[".pat-timeline-modal-overlay {\n    position: fixed;\n    inset: 0;\n    background: rgba(0, 0, 0, 0.45);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 9999;\n  }\n  \n  .pat-timeline-modal-content {\n    background: var(--clr-white);\n    width: 75%;\n    max-height: 90vh;\n    overflow-y: auto;\n    padding: 2rem 2rem 1.5rem;\n    border-radius: var(--radius);\n    box-shadow: var(--shadow-4);\n    position: relative;\n    animation: fadeInUp 0.3s ease-in-out;\n    font-family: var(--ff-primary);\n  }\n  \n  @keyframes fadeInUp {\n    from {\n      transform: translateY(24px);\n      opacity: 0;\n    }\n    to {\n      transform: translateY(0);\n      opacity: 1;\n    }\n  }\n  \n  .pat-timeline-close-btn {\n    position: absolute;\n    top: 14px;\n    right: 18px;\n    font-size: 1.2rem;\n    background-color: var(--clr-grey-9);\n    border: none;\n    border-radius: 50%;\n    width: 34px;\n    height: 34px;\n    cursor: pointer;\n    font-weight: bold;\n    color: var(--clr-grey-3);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: var(--transition);\n  }\n  \n  .pat-timeline-close-btn:hover {\n    background-color: var(--clr-grey-8);\n    transform: rotate(90deg);\n  }\n  \n  .pat-timeline-modal-header {\n    font-size: 1.5rem;\n    margin-bottom: 1.5rem;\n    font-weight: 600;\n    color: var(--clr-grey-1);\n    text-align: center;\n    border-bottom: 1px solid var(--clr-grey-8);\n    padding-bottom: 0.5rem;\n  }\n  \n  .pat-modal-section {\n    margin-bottom: 2rem;\n  }\n  \n  .pat-modal-row {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 0.5rem;\n    font-size: 0.95rem;\n    color: var(--clr-grey-3);\n  }\n  \n  .pat-modal-label {\n    font-weight: 500;\n    color: var(--clr-primary-5);\n    min-width: 130px;\n  }\n  \n  .pat-modal-value {\n    color: var(--clr-grey-2);\n    flex: 1;\n    /* text-align: right; */\n    word-break: break-word;\n  }\n  \n  .pat-modal-split {\n    display: flex;\n    gap: 1.5rem;\n    flex-wrap: wrap;\n  }\n  \n  .pat-modal-box {\n    flex: 1 1 48%;\n    /* background: var(--clr-primary-10); */\n    border: 1px solid var(--clr-primary-7);\n    border-left: 4px solid var(--clr-primary-6);\n    border-radius: var(--radius);\n    padding: 1.25rem 1rem;\n    box-shadow: var(--shadow-1);\n    transition: box-shadow 0.3s ease-in-out;\n  }\n  \n  .pat-modal-box:hover {\n    box-shadow: var(--shadow-3);\n  }\n  \n  .pat-modal-subheader {\n    font-size: 1.05rem;\n    font-weight: 600;\n    color: var(--clr-primary-5);\n    margin-bottom: 0.75rem;\n    border-bottom: 1px solid var(--clr-primary-6);\n    padding-bottom: 0.3rem;\n  }\n  \n  .pat-modal-box .pat-modal-row {\n    margin-bottom: 0.4rem;\n    font-size: 0.9rem;\n  }\n  \n  .pat-modal-value.single-line {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n  \n  @media (max-width: 1024px) {\n    .pat-modal-split {\n      flex-direction: column;\n    }\n  \n    .pat-modal-box {\n      flex: 1 1 100%;\n    }\n  }\n  \n  @media (max-width: 768px) {\n    .pat-modal-label {\n      min-width: 100px;\n    }\n  \n    .pat-modal-row {\n      flex-direction: column;\n      align-items: flex-start;\n    }\n  \n    .pat-modal-value {\n      text-align: left;\n      margin-top: 0.2rem;\n    }\n  }\n  \n/* Responsive Styles */\n\n@media (max-width: 768px) {\n    .pat-timeline-modal-content {\n      width: 90%;\n      padding: 1.5rem 1rem;\n      max-height: 85vh;\n      overflow-y: auto;\n      display: flex;\n      flex-direction: column;\n    }\n  \n    .pat-timeline-modal-header {\n      font-size: 1.25rem;\n      padding-bottom: 0.4rem;\n    }\n  \n    .pat-modal-subheader {\n      font-size: 1rem;\n    }\n  \n    .pat-modal-box {\n      padding: 1rem;\n      flex: 1 1 auto;\n      overflow-wrap: break-word;\n      word-break: break-word;\n    }\n  \n    .pat-modal-label {\n      font-size: 0.95rem;\n    }\n  \n    .pat-modal-value {\n      font-size: 0.95rem;\n    }\n  \n    .pat-modal-section,\n    .pat-modal-split {\n      flex-shrink: 0;\n    }\n  }\n  \n  @media (max-width: 480px) {\n    .pat-timeline-modal-content {\n      width: 95%;\n      padding: 1rem 0.75rem;\n      max-height: 85vh;\n      overflow-y: auto;\n      display: flex;\n      flex-direction: column;\n    }\n  \n    .pat-timeline-close-btn {\n      top: 10px;\n      right: 12px;\n      width: 30px;\n      height: 30px;\n      font-size: 1rem;\n    }\n  \n    .pat-modal-subheader {\n      font-size: 0.95rem;\n    }\n  \n    .pat-modal-box {\n      padding: 0.75rem;\n      flex: 1 1 auto;\n      overflow-wrap: break-word;\n      word-break: break-word;\n    }\n  \n    .pat-modal-label,\n    .pat-modal-value {\n      font-size: 0.9rem;\n    }\n  \n    .pat-modal-section,\n    .pat-modal-split {\n      flex-shrink: 0;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
